const styles = {
  paper: {
    maxWidth: '1280px',
    margin: '0 auto 100px'
  },
  section: {
    border: 'none',
    paddingTop: '70px',
    '& h3': {
      textAlign: 'center',
      width: '100%'
    }
  },
  container: {
    maxWidth: '40%',
    display: 'flex',
    justifyContent: 'space-around',
    margin: '30px auto 0'
  },
  button: {
    marginLeft: '20px',
    '& > svg': {
      marginLeft: '8px'
    }
  },
  action: {
    textAlign: 'center',
    margin: '30px 0'
  }
}

export default styles
